import clsx from 'clsx';
import React, { ClassAttributes, HTMLAttributes } from 'react';
import styles from './TableHead.module.css';

export const TableHead = ({
  className,
  ...props
}: JSX.IntrinsicAttributes &
  React.ClassAttributes<HTMLTableHeaderCellElement> &
  React.ThHTMLAttributes<HTMLTableHeaderCellElement>) => (
  <th className={clsx(styles.tableHead, className)} {...props} />
);
